<template>
  <div class="about">
    <h1>This is an about page</h1>
  </div>
</template>

<script>
export default {
  name: 'about',
  metaInfo: {
    title: 'MEAD | Tudo para projetos de Ensino a Distância',
    titleTemplate: 'Sobre - %s',
    meta: [
      { charset: 'utf-8' },
      { name: 'description', content: 'Tudo para projetos de Ensino a Distância' }
    ],
    htmlAttrs: {
      lang: 'pt-BR',
      amp: undefined
    }
  },
}
</script>
